import { gql } from '@apollo/client';

export const DeleteStandardImportMutationName = 'DeleteStandardImport';

export const DELETE_STANDARD_IMPORT_MUTATION = gql`
  mutation ${DeleteStandardImportMutationName}($id: ID!) {
    deleteStandardImport(id: $id) {
      id
      status
    }
  }
`;
